module.exports = __webpack_public_path__ + "static/media/nona-medium.dada5044.svg";